import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"facebook\"><path d=\"M12.82 24H1.32A1.32 1.32 0 0 1 0 22.68V1.32A1.32 1.32 0 0 1 1.32 0h21.36A1.32 1.32 0 0 1 24 1.32v21.36A1.32 1.32 0 0 1 22.68 24h-6.12v-9.29h3.12l.47-3.63h-3.59V8.77c0-1 .29-1.76 1.79-1.76h1.92V3.77a23.5 23.5 0 0 0-2.79-.15c-2.77 0-4.66 1.69-4.66 4.79v2.67H9.69v3.63h3.13V24z\" data-name=\"1.0.8-Navigation-/--/-Footer\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol